// src/prismicConfiguration.js
import * as prismic from '@prismicio/client';

export const repositoryName = 'rederefugia'; // Replace with your Prismic repository name
export const accessToken = 'MC5aZHV4U2hFQUFCOEFKTVRW.QDPvv71277-977-977-977-9fArvv71v77-9BB8_HO-_vVtB77-977-9LHbvv70tMe-_vUA177-9HA'; // Replace with your Prismic access token if needed

export const client = prismic.createClient(repositoryName, {
  accessToken: accessToken,
});
